import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Register from 'components/Auth/Register/index';
import Header, { LogoStyles } from 'components/Page/Header/Header';
import Page from 'components/Page/Page';
import BackButton from 'components/common/Form/BackButton/index';
import RoleChoice from 'components/Auth/Register/RoleChoice/RoleChoice';
import SubHeader from 'components/Page/SubHeader/SubHeader';
import styles from './RegisterPage.module.scss';

import Routes from 'constants/Routes';
import { UserContext } from 'context/UserContext';

function RegisterPage({ history, match }) {
    const { t } = useTranslation();
    document.title = `VocalViews ${t('pages.auth.register')}`;
    const { role } = match.params;
    const { authApi } = useContext(UserContext);

    const onRoleSelect = (role) => {
        const facebookToken = localStorage.getItem('facebookToken');
        const accessToken = localStorage.getItem('googleToken') || facebookToken;
        if (accessToken) {
            const type = facebookToken ? 'facebook' : 'google';
            authApi({ accessToken, role, type }, (err, res) => {
                localStorage.removeItem('googleToken');
                localStorage.removeItem('facebookToken');
                if (err) {
                    console.log(err);
                    return;
                }
                history.push(Routes.welcome.path);
            });
        } else {
            history.push(`${Routes.signUp.path}/${role.toLowerCase()}`);
        }
    };

    const toBack = () => history.goBack();
    const toHome = () => history.push(Routes.home.path);

    return (
        <>
            <Header
                logoStyle={role ? LogoStyles.light : LogoStyles.colored}
                headerContent={role && <BackButton text={null} light />}
            />
            <Page contentWrapperClassName={styles.contentWrapper}>
                {!role && <SubHeader title={t('pages.auth.roleChoice')} />}
                {role ? (
                    <Register goBack={toBack} role={role} toHome={toHome} />
                ) : (
                    <RoleChoice onClick={onRoleSelect} />
                )}
            </Page>
        </>
    );
}

export default withRouter(RegisterPage);
